import React, { HTMLAttributes } from 'react';

export const HighlightedCandidateCardInfo: React.FC<
	HTMLAttributes<HTMLParagraphElement> & { title: string; value: string }
> = ({ title, value }) => {
	return (
		<p
			style={{
				border: '2px dashed rgba(28, 220, 171, 0.9)',
				width: 'fit-content',
				borderRadius: '5px',
				padding: '2px 5px'
			}}
		>
			<b>{title}: </b>
			{value}
		</p>
	);
};
